import React, { useState } from "react";
import { KTCard, KTCardBody, KTSVG } from "../../../../_metronic/helpers";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment-jalaali";
import { getFanReportList } from "../../../api/report/reportApi";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const searchSchema = Yup.object().shape({
  nationalCode: Yup.string()
    .matches(/^[0-9]{10}$/, "کد ملی باید ۱۰ رقم باشد")
    .required("کد ملی الزامی است"),
});

function FanReport() {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<any>(null);
  const navigate = useNavigate();

  const initialValues = {
    nationalCode: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: searchSchema,
    onSubmit: async (values) => {
      refetch();
    },
  });

  const { refetch } = useQuery(
    ["users", formik.values.nationalCode],
    () =>
      getFanReportList({
        nationalCode: formik.values.nationalCode,
      }),
    {
      enabled: false,
      onSuccess: (data) => {
        setReportData(data);
      },
      onError: (error: any) => {
        if (error.response && error.response.status === 404) {
          setReportData(null);
        }
      },
      retry: 0,
    }
  );

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "success":
        return <span className="badge badge-light-success">موفق</span>;
      case "failed":
        return <span className="badge badge-light-danger">ناموفق</span>;
      default:
        return <span className="badge badge-light-warning">نامشخص</span>;
    }
  };

  return (
    <div className={"card"}>
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
        }
      >
        <h2>گزارش هوادار</h2>
      </div>
      <form onSubmit={formik.handleSubmit} className={"form"}>
        <div className={"card-body"}>
          <div className={"row  row-gap-10  mb-6"}>
            <div className="col-lg-8">
              <input
                type="text"
                className={`form-control form-control-lg form-control-solid ${
                  formik.touched.nationalCode && formik.errors.nationalCode
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="کد ملی را وارد کنید"
                {...formik.getFieldProps("nationalCode")}
              />
              {formik.touched.nationalCode && formik.errors.nationalCode && (
                <div className="invalid-feedback">
                  {formik.errors.nationalCode}
                </div>
              )}
            </div>
            <div className="col-lg-4">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || formik.isSubmitting}
              >
                {!loading && <span className="indicator-label">جستجو</span>}
                {loading && (
                  <span className="indicator-progress">
                    لطفا صبر کنید...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>

      {reportData && (
        <div>
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="card bg-light">
                <div className="card-body">
                  <h4 className="mb-4">اطلاعات هوادار</h4>
                  <div className="row">
                    <div className="col-md-3">
                      <p className="fw-bold mb-2">نام و نام خانوادگی:</p>
                      <p>
                        {reportData.tickets[0]?.user?.f_name +
                          " " +
                          reportData.tickets[0]?.user?.l_name}
                      </p>
                    </div>
                    <div className="col-md-3">
                      <p className="fw-bold mb-2">کد ملی:</p>
                      <p>{reportData.tickets[0]?.user?.national_code}</p>
                    </div>
                    <div className="col-md-3">
                      <p className="fw-bold mb-2">شماره تماس:</p>
                      <p>{reportData.tickets[0]?.user?.mobile}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={"p-c-30"}>
            <h3 className="pb-4">اطلاعات بلیت‌ها</h3>
            <table className="table table-light table-striped">
              <thead className="fw-bold">
                <tr>
                  <th>ردیف</th>
                  <th>عنوان مسابقه</th>
                  <th>تاریخ</th>
                  <th>مبلغ (ریال)</th>
                  <th>وضعیت</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {reportData.tickets.map((ticket: any, index: number) => (
                  <tr key={ticket.id}>
                    <td>{index + 1}</td>
                    <td>{ticket.match.title}</td>
                    <td>
                      {moment(ticket.created_at).format("jYYYY/jMM/jDD HH:mm")}
                    </td>
                    <td>{ticket.price.toLocaleString()}</td>
                    <td>{getStatusBadge(ticket.status)}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-icon btn-light-info btn-sm"
                        title="تاریخچه تراکنش‌ها"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/reports/fan-log-report", {
                            state: { userLogs: reportData.userLogs },
                          });
                        }}
                      >
                        <KTSVG
                          path="/media/icons/duotune/general/gen005.svg"
                          className="svg-icon-3"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!reportData && !loading && formik.submitCount > 0 && (
        <p className="text-center text-danger my-3">
          اطلاعاتی برای این کد ملی یافت نشد.
        </p>
      )}
    </div>
  );
}

export default FanReport;
